import * as React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {observer} from 'mobx-react';

function JudicialStageAdvanceModal({feature}) {
    const confirmIsDisabled = feature.judicialStageReason.trim() === '';
    return (
        <Dialog open={feature.judicialStageModalOpen} onClose={() => feature.closeJudicialStageModal()} fullWidth maxWidth="md">
            <DialogTitle>Solicitar {feature.nextJudicialStageLabel()}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Motivo"
                    value={feature.judicialStageReason}
                    onChange={(event) => feature.setJudicialStageReason(event.target.value)}
                    fullWidth
                    multiline
                    minRows={8}
                    autoFocus
                    margin="dense"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => feature.closeJudicialStageModal()}>Cancelar</Button>
                <Button
                    variant="contained"
                    disabled={confirmIsDisabled}
                    onClick={() => feature.requestJudicialStageAdvance()}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default observer(JudicialStageAdvanceModal);
